import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const VisualLabLanding = () => {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20, fontFamily: "'Nunito', sans-serif" }}>
      <SEO
        title="Visual STEM Lab – Geometry & Chemistry Builder"
        description="Build interactive geometry constructions and 3D molecules with AI-powered explanations. Save and share your projects."
        canonical="https://eluvent.com/visual-lab"
      />

      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, color: "#1e3a5f", margin: 0 }}>
          🧪 Visual STEM Lab
        </h1>
        <p style={{ fontSize: 18, color: "#64748b", marginTop: 8 }}>
          Visualise math and chemistry like never before. Build, explore, and learn with AI.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20 }}>
        {/* Geometry Card */}
        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: "#1e293b", margin: "0 0 8px" }}>
            📐 Geometry Builder
          </h2>
          <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6, marginBottom: 16 }}>
            Draw lines, angles, triangles, circles, and constructions. Measure and validate with AI.
          </p>
          <Link
            to="/visual-lab/geometry"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #fca311, #ff8c42)",
              color: "white",
              padding: "12px 24px",
              borderRadius: 30,
              fontWeight: 700,
              fontSize: 16,
              textDecoration: "none",
              boxShadow: "0 4px 12px rgba(252,163,17,0.4)"
            }}
          >
            Open Geometry
          </Link>
        </div>

        {/* Chemistry Card */}
        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: "#1e293b", margin: "0 0 8px" }}>
            ⚗️ Molecule Builder
          </h2>
          <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6, marginBottom: 16 }}>
            Build 3D molecular models, rotate them, and get IUPAC naming + VSEPR shape from AI.
          </p>
          <Link
            to="/visual-lab/chemistry"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
              color: "white",
              padding: "12px 24px",
              borderRadius: 30,
              fontWeight: 700,
              fontSize: 16,
              textDecoration: "none",
              boxShadow: "0 4px 12px rgba(139,92,246,0.4)"
            }}
          >
            Open Chemistry
          </Link>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <Link to="/visual-lab/projects" style={{ color: "#6366f1", fontWeight: 700, textDecoration: "none" }}>
          📁 View Saved Projects
        </Link>
      </div>
    </div>
  );
};

export default VisualLabLanding;